import React__default from 'react';
import isSameDay from 'date-fns/isSameDay';
import styles from './styles.css.js';
import { formatDate } from '@deal/date-utils';
import formatTZ from 'date-fns-tz/format';
import utcToZonedTime from 'date-fns-tz/utcToZonedTime';
import { useTimeZoneContext } from '../../containers/TimeZone/index.js';
import isSameWeek from 'date-fns/isSameWeek';
import isSameYear from 'date-fns/isSameYear';
import subDays from 'date-fns/subDays';

/**
 * A set of messages sent in quick succession. Each exchange in a conversation is headed by a date & time.
 */

var Exchange = function Exchange(_a) {
  var startedAt = _a.startedAt,
      children = _a.children;
  var timeZone = useTimeZoneContext().ianaTimeZone; // TODO: This component should be stateful to track the current date.
  //   The method is impure because it uses `new Date`.

  var now = new Date();
  var convertedDate = startedAt;
  var formattedDate;

  if (timeZone) {
    now = utcToZonedTime(now, timeZone);
    convertedDate = utcToZonedTime(convertedDate, timeZone);
  }

  if (isSameDay(convertedDate, now)) {
    formattedDate = 'Today';
  } else if (isSameDay(convertedDate, subDays(now, 1))) {
    formattedDate = 'Yesterday';
  } else if (isSameWeek(convertedDate, now)) {
    formattedDate = formatTZ(convertedDate, 'EEEE', {
      timeZone: timeZone
    });
  } else if (isSameYear(convertedDate, now)) {
    formattedDate = formatTZ(convertedDate, 'EEE, MMM d', {
      timeZone: timeZone
    });
  } else {
    formattedDate = formatTZ(convertedDate, 'EEE, MMM d, yyyy', {
      timeZone: timeZone
    });
  } // if `timeZone` is provided, add the time zone string ("PST") to the end of the date string


  var timeZoneString = timeZone ? formatTZ(convertedDate, ' zzz', {
    timeZone: timeZone
  }) : '';
  formattedDate += timeZoneString;
  return React__default.createElement("div", null, React__default.createElement("div", {
    className: styles.label
  }, React__default.createElement("hr", {
    className: styles.divider
  }), React__default.createElement("time", {
    className: styles.date,
    dateTime: startedAt.toISOString(),
    title: formatDate(startedAt, {
      format: 'long',
      includeDayOfWeek: true,
      ianaTimeZone: timeZone
    })
  }, formattedDate), React__default.createElement("hr", {
    className: styles.divider
  })), React__default.createElement("ul", {
    className: styles.messages
  }, children));
};

export default Exchange;
//# sourceMappingURL=index.js.map
